import { UpgradeHandoffClaimContext } from '@rhg/providers/upgrade-handoff-claim';
import { useContext } from 'react';

export function useUpgradeHandoffClaim() {
    return useContext(UpgradeHandoffClaimContext);
}
